module.exports = __webpack_public_path__ + "img/png-3.462a33e8.png";